import NotificationModalDialog from './notification-modal-dialog'

export default NotificationModalDialog
